// React libs
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// Components
import { sortBy } from 'lodash';
import moment from 'moment-timezone';
import LoadingOverlay from 'react-loading-overlay';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button } from 'reactstrap';
import axios from 'axios';
// Custom components
import BokFreightOptionAccordion from '../../components/Accordion/BokFreightOptionAccordion';
import ExtraCostSummarySlider from '../../components/Sliders/ExtraCostSummarySlider';
import PalletSlider from '../../components/Sliders/PalletSlider';
import ConfirmModal from '../../components/CommonModals/ConfirmModal';
import BokLineSlider from '../../components/Sliders/BokLineSlider';
import CustomerFreightProviderSlider from '../../components/Sliders/CustomerFreightProviderSlider';
// Services
import { getWeight } from '../../commons/helpers';
import { PALLETS } from '../../commons/constants';
import {
    getBokWithPricings,
    selectPricing,
    bookFreight,
    cancelFreight,
    sendEmail,
    onAddBokLine,
    onUpdateBokLine,
    onDeleteBokLine,
    repack,
    setNeedToUpdatePricings    
} from '../../state/services/bokService';
import { getPackageTypes } from '../../state/services/extraService';
import { API_HOST, HTTP_PROTOCOL } from '../../config';

class BokPricePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errorMessage: null,
            isCanceled: null,
            isBooked: null,
            sortedBy: 'lowest',
            isLoadingBok: false,
            isLoadingPricing: false,
            isLoadingOper: false,
            isRepacking: false,
            isUpdatingItemProduct: false,
            isShowExtraCostSummarySlider: false,
            isShowPalletSlider: false,
            isShowLineData: false,
            selectedPrice: {},
            selectedLine: null,
            selectedQuote: null,
            isShowTriggerEmailModal: false,
            isShowDeleteConfirmModal: false,
            isShowDeleteQuoteConfirmModal: false,
            isShowBokLineSlider: false,
            isShowCustomerFreightProviderSlider: false,
            currentPackedStatus: '',
            viewMode: 'salesView', // adminView | salesView
            isAdminView: false, // adminView | salesView
            isTimerRunning: false,
        };

        this.toggleExtraCostSummarySlider = this.toggleExtraCostSummarySlider.bind(this);
        this.togglePalletSlider = this.togglePalletSlider.bind(this);
        this.toggleTriggerEmailModal = this.toggleTriggerEmailModal.bind(this);
        this.toggleDeleteConfirmModal = this.toggleDeleteConfirmModal.bind(this);
        this.toggleDeleteQuoteConfirmModal = this.toggleDeleteQuoteConfirmModal.bind(this);
        this.toggleBokLineSlider = this.toggleBokLineSlider.bind(this);
        this.toggleCustomerFreightProviderSlider = this.toggleCustomerFreightProviderSlider.bind(this);
    }

    static propTypes = {
        getBokWithPricings: PropTypes.func.isRequired,
        selectPricing: PropTypes.func.isRequired,
        onBookFreight: PropTypes.func.isRequired,
        onCancelFreight: PropTypes.func.isRequired,
        onAddBokLine: PropTypes.func.isRequired,
        onUpdateBokLine: PropTypes.func.isRequired,
        onDeleteBokLine: PropTypes.func.isRequired,
        getPackageTypes: PropTypes.func.isRequired,
        packageTypes: PropTypes.array,
        sendEmail: PropTypes.func.isRequired,
        bokWithPricings: PropTypes.object,
        match: PropTypes.object,
        loadSuccess: PropTypes.bool,
        bookedSuccess: PropTypes.bool,
        canceledSuccess: PropTypes.bool,
        selectPricingSuccess: PropTypes.bool,
        repackSuccess: PropTypes.bool,
        lineOperationSuccess: PropTypes.bool,
        repack: PropTypes.func.isRequired,
        setNeedToUpdatePricings: PropTypes.func.isRequired,
        username: PropTypes.string,
        clientname: PropTypes.string,
    };

    componentDidMount() {
        const identifier = this.props.match.params.id;

        if (identifier && identifier.length > 32) {
            const that = this;
            this.props.getBokWithPricings(identifier);
            
            setTimeout(() => {
                that.props.getPackageTypes();
            }, 2000);

            this.setState({isLoadingBok: true});
        } else {
            this.setState({errorMessage: 'Wrong id.'});
        }
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        const {errorMessage, needToUpdatePricings, bookedSuccess, canceledSuccess, lineOperationSuccess, username, bokWithPricings} = newProps;

        if (errorMessage) {
            this.setState({errorMessage});
        }

        if (needToUpdatePricings) {
            const identifier = this.props.match.params.id;
            this.props.getBokWithPricings(identifier);
            this.setState({isLoadingBok: true});
        }

        if (bookedSuccess) {
            this.notify('Freight is booked successfully');
            this.setState({isBooked: true});
        }

        if (canceledSuccess) {
            this.notify('Freight is canceled successfully');
            this.setState({isCanceled: true});
            this.notify('Browser tab will be closed in 3 seconds');

            setTimeout(() => {
                open(location, '_self').close();
            }, 3000);
        }

        if (this.state.isLoadingBok && !this.props.loadSuccess && newProps.loadSuccess) {
            this.setState({isLoadingBok: false});
        }

        if (this.state.isLoadingBok && errorMessage) {
            this.setState({ isLoadingBok: false });
        }

        if (this.state.isLoadingPricing && !this.props.selectPricingSuccess && newProps.selectPricingSuccess) {
            this.setState({isLoadingPricing: false});
        }

        if (this.state.isLoadingOper && (!this.props.bookedSuccess && newProps.bookedSuccess)) {
            this.setState({isLoadingOper: false});
        }

        if (this.state.isLoadingOper && (!this.props.canceledSuccess && newProps.canceledSuccess)) {
            this.setState({isLoadingOper: false});
        }

        if (this.state.isUpdatingItemProduct && !this.props.lineOperationSuccess && lineOperationSuccess) {
            this.setState({isUpdatingItemProduct: false, isLoadingBok: true});
            this.props.getBokWithPricings(this.props.match.params.id);
        }

        if (this.state.isRepacking && !this.props.repackSuccess && newProps.repackSuccess) {
            this.setState({isRepacking: false, isLoadingBok: true});
            this.props.getBokWithPricings(this.props.match.params.id);
        }
        
        if (username) {
            if(username != 'jasonL_sales') {
                this.setState({isAdminView: true, viewMode: 'adminView'});
            }
        }

        if (!this.state.isTimerRunning && bokWithPricings) {
            if (bokWithPricings.b_client_name === 'Jason L') {
                const intervalId = setInterval(this.timer, 10000);
                this.setState({isTimerRunning: true, intervalId});
            }
        }
    }

    UNSAFE_componentWillUnmount() {
        // use intervalId from the state to clear the interval
        clearInterval(this.state.intervalId);
    }

    notify = (text) => toast(text);

    copyToClipBoard = async text => {
        try {
            await navigator.clipboard.writeText(text);
            this.notify('Copied!');
        } catch (err) {
            this.notify('Failed to copy!');
        }
    };

    timer = () => {
        const {bokWithPricings} = this.props;

        const options = {
            method: 'get',
            url: HTTP_PROTOCOL + '://' + API_HOST + '/bok/quote-count/?identifier=' + bokWithPricings.pk_auto_id,
        };

        axios(options).then((response) => {
            if (response.data.code === 'does_exist') {
                if (response.data.result.quote_count !== bokWithPricings.pricings.length) {
                    this.props.setNeedToUpdatePricings();
                }

                if (response.data.result.quote_status === 'finished') {
                    clearInterval(this.state.intervalId);
                    this.setState({isTimerRunning: false, intervalId: null});
                }
            }
        });
    }

    onClickColumn = (arg) => {
        this.setState({sortedBy: arg});
    }

    onClickCancelBtn() {
        this.setState({isLoadingOper: true});
        this.props.onCancelFreight(this.props.match.params.id);
    }

    onClickBookBtn() {
        this.setState({isLoadingOper: true});
        this.props.onBookFreight(this.props.match.params.id);
    }

    onSelectPricing(cost_id, islocking=false) {
        this.setState({isLoadingPricing: true});
        this.props.selectPricing(cost_id, this.props.match.params.id, islocking);
    }

    onLockPricing(costId, selectedCostId, lockStatus) {
        if (!lockStatus) {
            this.onSelectPricing(costId, true);
        } else {
            if (costId === selectedCostId) {
                this.onSelectPricing(costId, !lockStatus);
            } else {
                this.onSelectPricing(costId, lockStatus);
            }
        }
    }

    toggleExtraCostSummarySlider() {
        this.setState(prevState => ({isShowExtraCostSummarySlider: !prevState.isShowExtraCostSummarySlider}));
    }

    togglePalletSlider() {
        this.setState(prevState => ({isShowPalletSlider: !prevState.isShowPalletSlider}));
    }

    toggleTriggerEmailModal() {
        this.setState(prevState => ({isShowTriggerEmailModal: !prevState.isShowTriggerEmailModal}));
    }

    toggleDeleteConfirmModal() {
        this.setState(prevState => ({isShowDeleteConfirmModal: !prevState.isShowDeleteConfirmModal}));
    }

    toggleDeleteQuoteConfirmModal() {
        this.setState(prevState => ({isShowDeleteQuoteConfirmModal: !prevState.isShowDeleteQuoteConfirmModal}));
    }

    onClickShowLineData(bok_2) {
        this.setState({isShowLineData: true, selectedBok_2Id: bok_2.pk_booking_lines_id});
    }

    toggleBokLineSlider() {
        this.setState(prevState => ({isShowBokLineSlider: !prevState.isShowBokLineSlider}));
    }

    toggleCustomerFreightProviderSlider() {
        this.setState(prevState => ({isShowCustomerFreightProviderSlider: !prevState.isShowCustomerFreightProviderSlider}));
    }

    toggleManualRepackModal() {
        this.setState(prevState => ({isShowManualRepackModal: !prevState.isShowManualRepackModal}));
    }

    onClickRepack(status) {
        const {bokWithPricings} = this.props;

        if (status) {
            this.setState({isShowPalletSlider: true});
        } else {
            this.setState({isRepacking: true, isShowLineData: false, currentPackedStatus: 'auto'});
            this.props.repack(bokWithPricings.pk_auto_id, 'auto', null);
        }
    }

    onSelectPallet(palletId) {
        const {bokWithPricings} = this.props;

        this.setState({isRepacking: true, isShowLineData: false, currentPackedStatus: 'auto'});
        this.props.repack(bokWithPricings.pk_auto_id, 'auto', palletId);
        this.togglePalletSlider();
    }

    onClickSurcharge(price) {
        this.setState({selectedPrice: price});
        this.toggleExtraCostSummarySlider();
    }

    onClickConfirmBtn(type) {
        const {bokWithPricings} = this.props;

        if (type === 'trigger-email') {
            // Send "picking slip printed" email manually
            this.notify('Booking will be sent in 1 minute!');
            this.props.sendEmail(this.props.match.params.id);
            this.toggleTriggerEmailModal();
        } else if (type === 'manual-from-original') {
            this.props.repack(bokWithPricings.pk_auto_id, type, null);
            this.setState({isRepacking: true, currentPackedStatus: 'manual'});
            this.toggleManualRepackModal();
        } else if (type === 'manual-from-auto') {
            this.props.repack(bokWithPricings.pk_auto_id, type, null);
            this.setState({isRepacking: true, currentPackedStatus: 'manual'});
            this.toggleManualRepackModal();
        } else if (type === 'enter-from-scratch') {
            this.setState({currentPackedStatus: 'manual'});
            this.toggleManualRepackModal();
        }
    }

    onclickAddLine() {
        this.setState({selectedLine: null});
        this.toggleBokLineSlider();
    }

    onClickEditLine(line) {
        this.setState({selectedLine: line});
        this.toggleBokLineSlider();
    }

    onClickDeleteLine(line) {
        this.setState({selectedLine: line});
        this.toggleDeleteConfirmModal();
    }

    onUpdateBokLine(newLine, type) {
        const {bokWithPricings} = this.props;
        const {selectedLine, currentPackedStatus} = this.state;

        if (type === 'add') {
            newLine['fk_header_id'] = bokWithPricings['pk_header_id'];
            newLine['b_093_packed_status'] = currentPackedStatus;
            this.props.onAddBokLine(newLine);
            this.toggleBokLineSlider();
        } else if (type === 'update') {
            this.props.onUpdateBokLine(selectedLine.pk_lines_id, newLine);
            this.toggleBokLineSlider();
        } else {
            this.props.onDeleteBokLine(selectedLine.pk_lines_id);
            this.toggleDeleteConfirmModal();
        }

        this.setState({isUpdatingItemProduct: true});
    }

    // status: `original`, `auto`, `manual`
    onChangePackedStatus(status) {
        const {bokWithPricings} = this.props;

        // Reset
        if (status === 'reset') {
            this.props.repack(bokWithPricings.pk_auto_id, '-' + this.state.currentPackedStatus, null);
            this.setState({isRepacking: true, currentPackedStatus: 'original'});
            return;
        } else if (status === 'quote') {
            this.props.repack(bokWithPricings.pk_auto_id, `${status}-${this.state.currentPackedStatus}`, null);
            this.setState({isRepacking: true});
            return;
        }

        const currentPackedStatus = status;
        const filteredProducts = bokWithPricings['bok_2s'].filter(bok_2 => bok_2['b_093_packed_status'] === currentPackedStatus);

        if (filteredProducts.length === 0) {
            if (status === 'auto') {
                this.togglePalletSlider();
            } else if (status === 'original') {
                this.setState({currentPackedStatus});
            } else {
                this.toggleManualRepackModal();
            }
        } else {
            this.setState({currentPackedStatus});
        }
    }

    onClickViewMode(viewMode) {
        this.setState({viewMode: viewMode});
    }

    onClickCustomerFreightProvider() {
        this.setState({selectedQuote: null});
        this.toggleCustomerFreightProviderSlider();
    }    

    onClickEditQuote(quote) {
        this.setState({selectedQuote: quote});
        this.toggleCustomerFreightProviderSlider();
    }

    onClickDeleteQuote(quote) {
        this.setState({selectedQuote: quote});
        this.toggleDeleteQuoteConfirmModal();
    }

    onSubmitCustomerFreightProvider() {
        this.toggleCustomerFreightProviderSlider();
        this.props.getBokWithPricings(this.props.match.params.id);
    }

    onDeleteQuote() {
        const { selectedQuote } = this.state;
        const options = {
            method: 'delete',
            url: `${HTTP_PROTOCOL}://${API_HOST}/pricing/${selectedQuote.cost_id}/delete/`,
        };
        axios(options)
            .then(() => {
                this.notify('Successfully Done!');
                this.props.getBokWithPricings(this.props.match.params.id);
            })
            .catch((error) => {
                this.notify('Failed: ' + error);
            });
        this.toggleDeleteQuoteConfirmModal();
    }

    render() {
        const {sortedBy, isBooked, isCanceled, isShowLineData, selectedBok_2Id, currentPackedStatus, viewMode, isAdminView, isTimerRunning} = this.state;
        const {bokWithPricings, clientname} = this.props;
        const isLoggedIn = localStorage.getItem('isLoggedIn');

        let bok_1, bok_2s, bok_3s, pricings;
        let isPricingPage = true;
        let canBeChanged = true;
        let sortedPricings = [];
        let isSalesQuote = false;
        let totalCubicMeter = 0;
        let totalLinesCnt = 0;
        let totalLinesKg = 0;
        let hasUnknownItems = false;
        let hasNonPalletItems = false;
        let errorList = [];
        let lowest_price_summary = 'not available';
        let _currentPackedStatus = currentPackedStatus || 'original';

        if (bokWithPricings) {
            // Show `Auto Repack` as default when it is available
            const bok_2s_auto = bokWithPricings['bok_2s'].filter(bok_2 => bok_2['b_093_packed_status'] === 'auto');
            if (!currentPackedStatus && bok_2s_auto.length > 0) _currentPackedStatus = 'auto';
        }

        if (isBooked || isCanceled || (bokWithPricings && Number(bokWithPricings['success']) !== 3) ) {
            canBeChanged = false;
        }

        if (
            bokWithPricings &&
            bokWithPricings['b_client_order_num'][0] === 'Q' &&
            bokWithPricings['b_client_order_num'][1] === '_'
        ) {
            isSalesQuote = true;
        }

        if (bokWithPricings) {
            bokWithPricings['pricings'].map((price, index) => {
                bokWithPricings['pricings'][index]['sell'] = parseFloat((price['client_mu_1_minimum_values'] * (1 + price['client_customer_mark_up'])).toFixed(2));
            });
        }

        let salesViewPricings;
        if (bokWithPricings && viewMode === 'salesView') {
            let customerCollectPrice;
            let inHouseFleetPrice;
            let dmeLinehaulPrice;
            let lowestPrice1;
            let lowestPrice2;
            let _sortedPricings = sortBy(bokWithPricings['pricings'], ['sell']);

            _sortedPricings
                .filter((price) => price['packed_status'] === _currentPackedStatus)
                .map((price) => {
                    if (!customerCollectPrice && price['fp_name'] === 'Customer Collect')
                        customerCollectPrice = price;

                    if (!dmeLinehaulPrice && price['fp_name'] === 'Deliver-ME')
                        dmeLinehaulPrice = price;

                    if (!inHouseFleetPrice && price['fp_name'] === 'In House Fleet')
                        inHouseFleetPrice = price;

                    if (
                        !lowestPrice1 &&
                        price['fp_name'] !== 'Customer Collect' &&
                        price['fp_name'] !== 'In House Fleet' &&
                        price['fp_name'] !== 'Deliver-ME'
                    )
                        lowestPrice1 = price;

                    if (
                        lowestPrice1 &&
                        !lowestPrice2 &&
                        lowestPrice1['cost_id'] !== price['cost_id'] &&
                        price['fp_name'] !== 'Customer Collect' &&
                        price['fp_name'] !== 'In House Fleet' &&
                        price['fp_name'] !== 'Deliver-ME'
                    )
                        lowestPrice2 = price;
                });


            let _pricings = [];
            if (inHouseFleetPrice || dmeLinehaulPrice) {                
                if (customerCollectPrice) _pricings.push(customerCollectPrice);
                if (inHouseFleetPrice) _pricings.push(inHouseFleetPrice);
                if (dmeLinehaulPrice) _pricings.push(dmeLinehaulPrice);
                if (lowestPrice1) _pricings.push(lowestPrice1);
            } else {
                if (customerCollectPrice) _pricings.push(customerCollectPrice);
                if (inHouseFleetPrice) _pricings.push(inHouseFleetPrice);
                if (dmeLinehaulPrice) _pricings.push(dmeLinehaulPrice);
                if (lowestPrice1) _pricings.push(lowestPrice1);
                if (lowestPrice2) _pricings.push(lowestPrice2);
            }

            salesViewPricings = _pricings;
        }

        let filteredPricings;
        if (bokWithPricings) filteredPricings = salesViewPricings || bokWithPricings['pricings'];

        if (bokWithPricings && sortedBy === 'lowest') {
            sortedPricings = sortBy(filteredPricings, ['sell']);
        } else if (bokWithPricings && sortedBy === 'fastest') {
            sortedPricings = sortBy(filteredPricings, ['eta_in_hour']);
        }

        if (bokWithPricings && filteredPricings) {
            const _pricings = sortBy(filteredPricings, ['sell']);

            if (_pricings.length > 0) {
                const lowest_price = _pricings[0];
                let packed_status_title = '';

                if (lowest_price.packed_status === 'original')
                    packed_status_title = 'Send As Is';
                else if (lowest_price.packed_status === 'auto')
                    packed_status_title = 'Auto Repack';
                else if (lowest_price.packed_status === 'manual')
                    packed_status_title = 'Manual Repack';

                lowest_price_summary = `${packed_status_title} | Freight Provider: ${lowest_price.fp_name} | Cost: $${lowest_price.sell}`;
            }
        }

        if (bokWithPricings) {
            bok_1 = bokWithPricings;

            if (bok_1 && bok_1['zb_105_text_5']) {
                // Errors are joined with delimiter('***')
                errorList = bok_1['zb_105_text_5']
                    .split('***')
                    .map((error, index) => {
                        if (error.indexOf('Error') !== -1)
                            return (<li key={index} className={'c-red ignored-items'}>{index + 1}) {error}</li>);
                        else
                            return (<li key={index} className={'c-orange ignored-items'}>{index + 1}) {error}</li>);
                    });
            }

            bok_2s = bok_1['bok_2s']
                .filter(bok_2 => bok_2['b_093_packed_status'] === _currentPackedStatus)
                .map((bok_2, index) => {
                    totalLinesKg += Number.parseFloat(getWeight(bok_2['l_002_qty'], bok_2['l_008_weight_UOM'], bok_2['l_009_weight_per_each']));
                    totalLinesCnt += bok_2['l_002_qty'];
                    totalCubicMeter += bok_2['pallet_cubic_meter'];

                    let packedCubicMeter = 0;
                    let isUnknownLine = bok_2['l_003_item'].indexOf('(ZERO Dims') > -1;

                    if (!hasUnknownItems && isUnknownLine)
                        hasUnknownItems = true;

                    let isNonPalletLine = false;
                    if (bok_2['b_093_packed_status'] === 'auto') {
                        isNonPalletLine = !PALLETS.includes(bok_2['l_001_type_of_packaging'].toUpperCase());
                        if (!hasNonPalletItems && isNonPalletLine)
                            hasNonPalletItems = true;
                    }

                    bok_3s = bok_1['bok_3s']
                        .filter(bok_3 => bok_3.fk_booking_lines_id === bok_2['pk_booking_lines_id'])
                        .map(bok_3 => {
                            packedCubicMeter += bok_3['cubic_meter'];
                        });

                    return (
                        <tr key={index} className={isUnknownLine ? 'unknown' : (isNonPalletLine ? 'danger' : null)}>
                            <td>{bok_2['l_001_type_of_packaging']}</td>
                            <td>{bok_2['zbld_131_decimal_1']}</td>
                            <td>{bok_2['e_item_type']}</td>
                            <td>{bok_2['l_003_item']}</td>
                            <td>{bok_2['l_002_qty']}</td>
                            <td>{bok_2['l_004_dim_UOM']}</td>
                            <td>{bok_2['l_005_dim_length']}</td>
                            <td>{bok_2['l_006_dim_width']}</td>
                            <td>{bok_2['l_007_dim_height']}</td>
                            <td>{bok_2['pallet_cubic_meter'].toFixed(3)} (m3)</td>
                            <td>{(bok_2['l_002_qty'] * bok_2['l_009_weight_per_each']).toFixed(3)} ({bok_2['l_008_weight_UOM']})</td>
                            {_currentPackedStatus === 'auto' ? <td>{packedCubicMeter.toFixed(3)} (m3)</td> : null}
                            {_currentPackedStatus === 'auto' ? <td><Button color="primary" onClick={() => this.onClickShowLineData(bok_2)}>Show LineData</Button></td> : null}
                            <td>
                                <Button color="primary" onClick={() => this.onClickEditLine(bok_2)}>Edit</Button>{'   '}
                                <Button color="danger" onClick={() => this.onClickDeleteLine(bok_2)}>Delete</Button>
                            </td>
                        </tr>
                    );
                });

            pricings = sortedPricings
                .filter(pricing => pricing.packed_status === _currentPackedStatus)
                .filter(pricing => {
                    if (clientname !== 'dme')
                        return pricing['fp_name'] !== 'MRL Sampson';
                    return true;
                })
                .map((price, index) => {
                    const clientSalesTotal = bokWithPricings.b_094_client_sales_total;
                    let clientSalesTotal5Percent = 0;
                    let percentOfClientSalesTotal = 0;

                    if (clientSalesTotal) clientSalesTotal5Percent = clientSalesTotal * 0.06;

                    let clientCustomerMarkup = (price['client_customer_mark_up'] * 100).toFixed(2);
                    let clientCustomerPrice = price['sell'];

                    if (price['cost'] > 0 && clientSalesTotal5Percent > clientCustomerPrice) {
                        clientCustomerMarkup = ((clientSalesTotal5Percent / price['client_mu_1_minimum_values']) - 1) * 100;
                        clientCustomerMarkup = clientCustomerMarkup.toFixed(2);
                        clientCustomerPrice = clientSalesTotal5Percent;
                    }

                    // Sell $ / Sales Order Total $
                    if (clientSalesTotal) percentOfClientSalesTotal = (clientCustomerPrice / clientSalesTotal * 100).toFixed(2);

                    return (
                        <tr key={index} className={bok_1.quote_id === price.cost_id ? 'selected' : null}>
                            <td>
                                {price['fp_name']}
                            </td>
                            <td>
                                {price['vehicle_name'] ? `${price['service_desc']} (${price['vehicle_name']})` : price['service_desc']}
                            </td>
                            <td className={viewMode === 'salesView' ? 'none' : null}>
                                ${price['cost_dollar'].toFixed(2)}
                                &nbsp;&nbsp;&nbsp;
                                <i className="fa fa-copy" onClick={() => this.copyToClipBoard(price['cost_dollar'].toFixed(2))}></i>
                            </td>
                            <td className={viewMode === 'salesView' ? 'none' : null}>
                                {(price['mu_percentage_fuel_levy'] * 100).toFixed(2)}%
                            </td>
                            <td  className={viewMode === 'salesView' ? 'none' : null}>
                                ${price['fuel_levy_base_cl'].toFixed(2)}
                            </td>
                            <td className={viewMode === 'salesView' ? 'none' : null}>
                                ${price['surcharge_total_cl'].toFixed(2)} {price['surcharge_total_cl'].toFixed(2) > 0 ? <i className="fa fa-dollar-sign" onClick={() => this.onClickSurcharge(price)}></i> : ''}
                            </td>
                            <td className={viewMode === 'salesView' ? 'none' : null}>
                                ${price['client_mu_1_minimum_values'].toFixed(2)}
                                &nbsp;&nbsp;&nbsp;
                                <i className="fa fa-copy" onClick={() => this.copyToClipBoard(price['client_mu_1_minimum_values'].toFixed(2))}></i>
                            </td>
                            <td className={viewMode === 'salesView' ? 'none' : null}>
                                {clientCustomerMarkup}%
                            </td>
                            {(bokWithPricings && bokWithPricings.b_094_client_sales_total) ? <td>{percentOfClientSalesTotal}%</td> : null}
                            <td>
                                ${clientCustomerPrice.toFixed(2)}&nbsp;&nbsp;&nbsp;
                                <i className="fa fa-copy" onClick={() => this.copyToClipBoard(clientCustomerPrice)}></i>
                            </td>
                            <td  className={viewMode === 'salesView' ? 'none' : null}>
                                {moment(bok_1['b_021_b_pu_avail_from_date']).add(Math.ceil(price['eta_in_hour'] / 24), 'd').format('YYYY-MM-DD')} ({price['eta']})
                            </td>
                            {isPricingPage && !isSalesQuote &&
                                <td>
                                    <Button
                                        className='btn-sm'
                                        color={bok_1.quote_id === price.cost_id ? 'success' : 'primary'}
                                        disabled={canBeChanged ? null : 'disabled'}
                                        onClick={() => this.onSelectPricing(price.cost_id, bok_1.b_092_is_quote_locked)}
                                    >
                                        {bok_1.quote_id === price.cost_id ? <i className="fa fa-check"></i> : null} {bok_1.quote_id === price.cost_id ? 'Selected' : 'Select'}
                                    </Button>
                                    {price.provider === 'Customer' && 
                                        <Button
                                            className='btn-sm btn-icon'
                                            color='primary'
                                            disabled={isLoggedIn === 'true' ? null : 'disabled'}
                                            onClick={() => this.onClickEditQuote(price)}
                                        >
                                            <i className='fa fa-pencil-alt'/>
                                        </Button>
                                    }
                                    {price.provider === 'Customer' && 
                                        <Button
                                            className='btn-sm btn-icon'
                                            color='danger'
                                            disabled={bok_1.quote_id !== price.cost_id && isLoggedIn === 'true' ? null : 'disabled'}
                                            onClick={() => this.onClickDeleteQuote(price)}
                                        >
                                            <i className='fa fa-trash'/>
                                        </Button>
                                    }
                                </td>
                            }
                            {isPricingPage && !isSalesQuote &&
                                <td>
                                    <input
                                        type='checkbox'
                                        color={bok_1.quote_id === price.cost_id ? 'success' : 'primary'}
                                        checked={bok_1.quote_id === price.cost_id && bok_1.b_092_is_quote_locked}
                                        disabled={canBeChanged ? null : 'disabled'}
                                        onClick={() => this.onLockPricing(price.cost_id, bok_1.quote_id, bok_1.b_092_is_quote_locked)}
                                    />
                                </td>
                            }
                        </tr>
                    );
                });

            bok_3s = [];
            if (isShowLineData) {
                bok_3s = bok_1['bok_3s']
                    .filter(bok_3 => bok_3.fk_booking_lines_id === selectedBok_2Id && _currentPackedStatus !== 'manual')
                    .map((bok_3, index) => (
                        <tr key={index}>
                            <td>{bok_3['zbld_104_text_4']}</td>
                            <td>{bok_3['zbld_122_integer_2']}</td>
                            <td>{bok_3['zbld_103_text_3']}</td>
                            <td>{bok_3['zbld_105_text_5']}</td>
                            <td>{bok_3['zbld_101_text_1']}</td>
                            <td>{bok_3['zbld_131_decimal_1']}</td>
                            <td>{bok_3['zbld_132_decimal_2']}</td>
                            <td>{bok_3['zbld_133_decimal_3']}</td>
                            <td>{bok_3['zbld_122_integer_2'] * bok_3['zbld_134_decimal_4']} ({bok_3['zbld_102_text_2']})</td>
                            <td>{bok_3['cubic_meter'].toFixed(3)} (m3)</td>
                        </tr>
                    ));
            }
        }

        return (
            <LoadingOverlay
                active={this.state.isLoadingBok}
                styles={{height: 'calc(100% - 114px)'}}
                className="loading-pane"
                spinner
                text='Loading...'
            >
                <section className="bok-price">
                    {this.state.errorMessage || !bok_1 ?
                        <h1>{this.state.errorMessage}</h1>
                        :
                        <div>
                            <h3><i className="fa fa-circle"></i> Main Info:</h3>
                            <div className="main-info">
                                <div className="">
                                    <strong>Client Name: </strong><span>{bok_1['b_client_name']}</span><br />
                                    <strong>Client Order Number: </strong><span>{bok_1['b_client_order_num']}</span><br />
                                    <strong>Client Sales Invoice Number: </strong><span>{bok_1['b_client_sales_inv_num']}</span><br />
                                    <strong>Despatch Date: </strong><span>{bok_1['b_021_b_pu_avail_from_date']}</span><br />
                                </div>
                                <div className="pu-info disp-inline-block">
                                    <label>Pickup From</label><br />
                                    <div className="title disp-inline-block">
                                        <strong>Entity Name: </strong><br />
                                        <strong>Street 1: </strong><br />
                                        <strong>Street 2: </strong><br />
                                        <strong>Suburb: </strong><br />
                                        <strong>State: </strong><br />
                                        <strong>PostalCode: </strong><br />
                                        <strong>Country: </strong><br />
                                        <strong>Contact Name: </strong><br />
                                        <strong>Email: </strong><br />
                                        <strong>Phone: </strong><br />
                                    </div>
                                    <div className="data disp-inline-block">
                                        <span>{bok_1['b_028_b_pu_company']}</span><br />
                                        <span>{bok_1['b_029_b_pu_address_street_1']}</span><br />
                                        {bok_1 && bok_1['b_030_b_pu_address_street_2'] && (<span>{bok_1['b_030_b_pu_address_street_2']}</span>)}<br />
                                        <span>{bok_1['b_032_b_pu_address_suburb']}</span><br />
                                        <span>{bok_1['b_031_b_pu_address_state']}</span><br />
                                        <span>{bok_1['b_033_b_pu_address_postalcode']}</span><br />
                                        <span>{bok_1['b_034_b_pu_address_country']}</span><br />
                                        <span>{bok_1['b_035_b_pu_contact_full_name']}</span><br />
                                        <span>{bok_1['b_037_b_pu_email']}</span><br />
                                        <span>{bok_1['b_038_b_pu_phone_main']}</span><br />
                                    </div>
                                </div>
                                <div className="de-info disp-inline-block">
                                    <label>Deliver To</label><br />
                                    <div className="title disp-inline-block">
                                        <strong>Entity Name: </strong><br />
                                        <strong>Street 1: </strong><br />
                                        <strong>Street 2: </strong><br />
                                        <strong>Suburb: </strong><br />
                                        <strong>State: </strong><br />
                                        <strong>PostalCode: </strong><br />
                                        <strong>Country: </strong><br />
                                        <strong>Contact Name: </strong><br />
                                        <strong>Email: </strong><br />
                                        <strong>Phone: </strong><br />
                                    </div>
                                    <div className="data disp-inline-block">
                                        <span>{bok_1['b_054_b_del_company']}</span><br />
                                        <span>{bok_1['b_055_b_del_address_street_1']}</span><br />
                                        {bok_1 && bok_1['b_056_b_del_address_street_2'] && (<span>{bok_1['b_056_b_del_address_street_2']}</span>)}<br />
                                        <span>{bok_1['b_058_b_del_address_suburb']}</span><br />
                                        <span>{bok_1['b_057_b_del_address_state']}</span><br />
                                        <span>{bok_1['b_059_b_del_address_postalcode']}</span><br />
                                        <span>{bok_1['b_060_b_del_address_country']}</span><br />
                                        <span>{bok_1['b_061_b_del_contact_full_name']}</span><br />
                                        <span>{bok_1['b_063_b_del_email']}</span><br />
                                        <span>{bok_1['b_064_b_del_phone_main']}</span><br />
                                    </div>
                                </div>
                                <ul>{errorList}</ul>
                            </div>
                            <LoadingOverlay
                                active={this.state.isLoadingBok || this.state.isLoadingPricing || this.state.isLoadingOper || this.state.isRepacking || this.state.isUpdatingItemProduct}
                                spinner
                                text='Loading...'
                            >
                                <BokFreightOptionAccordion
                                    bok_1={bok_1}
                                />
                                <h3><i className="fa fa-circle"></i> Lines:</h3>
                                <div className='action-btns'>
                                    <Button
                                        color={_currentPackedStatus === 'original' ? 'success' : 'secondary'}
                                        onClick={() => this.onChangePackedStatus('original')}
                                    >
                                        Send As Is
                                    </Button>
                                    <Button
                                        color={_currentPackedStatus === 'auto' ? 'success' : 'secondary'}
                                        onClick={() => this.onChangePackedStatus('auto')}
                                    >
                                        Auto Repack
                                        {hasNonPalletItems && (
                                            <i className="fa fa-exclamation-triangle c-red" aria-hidden="true"></i>
                                        )}
                                    </Button>
                                    <Button
                                        color={_currentPackedStatus === 'manual' ? 'success' : 'secondary'}
                                        onClick={() => this.onChangePackedStatus('manual')}
                                    >
                                        Manual Repack
                                    </Button>
                                    <Button
                                        className='mar-left-30 reset'
                                        color='danger'
                                        onClick={() => this.onChangePackedStatus('reset')}
                                        disabled={(_currentPackedStatus === 'auto' || _currentPackedStatus === 'manual') ? '' : 'disabled'}
                                        title="Reset all lines and LineDetails."
                                    >
                                        Reset
                                    </Button>
                                    <p className='lowest-price-summary disp-inline-block mar-left-30'><strong>Your Lowest Cost Option is - </strong>{lowest_price_summary}</p>
                                    {
                                        (bokWithPricings && bokWithPricings.b_094_client_sales_total) && 
                                            <p className='lowest-price-summary disp-inline-block mar-left-30'>
                                                <strong>Sales Order Total $:</strong> ${bokWithPricings.b_094_client_sales_total.toLocaleString('en-US')}
                                            </p>
                                    }
                                    <Button
                                        className='float-r'
                                        color='primary'
                                        onClick={() => this.onChangePackedStatus('quote')}
                                        disabled={bok_2s.length > 0 ? null : 'disabled'}
                                        title="Get quotes again"
                                    >
                                        Complete & Calc Quote
                                    </Button>
                                </div>
                                {bok_1 && bok_1['b_010_b_notes'] && <p className='c-red ignored-items none'><strong>Unknown lines: </strong>{bok_1['b_010_b_notes']}</p>}
                                {hasUnknownItems &&
                                    <p className='c-red ignored-items'>
                                        Red highlighted lines are all unknown lines, and are excluded from freight rate calculation. Please click edit button to manually populate. (Unavailable for auto repacked status)
                                    </p>
                                }
                                {hasNonPalletItems &&
                                    <p className='c-red ignored-items'>
                                        Red highlighted lines are non-pallet items. Please click edit button to manually populate. (Unavailable for auto repacked status)
                                    </p>
                                }
                                {totalLinesCnt ?
                                    <table className="table table-hover table-bordered sortable fixed_headers">
                                        <thead>
                                            <tr>
                                                <th>Total Quantity</th>
                                                <th>Total Weight (Kg)</th>
                                                <th>Total Cubic Meter (M3)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{totalLinesCnt}</td>
                                                <td>{totalLinesKg}</td>
                                                <td>{totalCubicMeter.toFixed(2)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    :
                                    null
                                }
                                <table className="table table-hover table-bordered sortable fixed_headers">
                                    <thead>
                                        <tr>
                                            <th className="valign-top">Type Of Packaging</th>
                                            <th className="valign-top">Seq #</th>
                                            <th className="valign-top">Item No</th>
                                            <th className="valign-top">Item Descripton</th>
                                            <th className="valign-top">Qty</th>
                                            <th className="valign-top">Dim UOM</th>
                                            <th className="valign-top">Length</th>
                                            <th className="valign-top">Width</th>
                                            <th className="valign-top">Height</th>
                                            <th className="valign-top">{_currentPackedStatus === 'auto' ? 'Pallet CBM' : 'CBM'}</th>
                                            <th className="valign-top">Total Weight</th>
                                            {_currentPackedStatus === 'auto' ? <th className="valign-top">Total Packed CBM</th> : null}
                                            {_currentPackedStatus === 'auto' ? <th className="valign-top">Show Line Details</th> : null}
                                            <th className="valign-top">
                                                Actions <Button color="success" className='float-r' onClick={() => this.onclickAddLine()}>New Line</Button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bok_2s}
                                    </tbody>
                                </table>
                                {isShowLineData && <h3><i className="fa fa-circle"></i> Line Data:</h3>}
                                {isShowLineData &&
                                    <table className="table table-hover table-bordered sortable fixed_headers">
                                        <thead>
                                            <tr>
                                                <th>Type Of Packaging</th>
                                                <th>Quantity</th>
                                                <th>Item No</th>
                                                <th>Item Description</th>
                                                <th>Dim UOM</th>
                                                <th>Length</th>
                                                <th>Width</th>
                                                <th>Height</th>
                                                <th>Total Weight</th>
                                                <th>CBM</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {bok_3s}
                                        </tbody>
                                    </table>
                                }
                                <h3>
                                    <i className="fa fa-circle"></i> Freight Rates:{'   '}
                                    <Button
                                        className='disp-inline-block'
                                        color={viewMode === 'salesView' ? 'primary' : 'secondary'}
                                        onClick={() => this.onClickViewMode('salesView')}
                                    >
                                        Sales View
                                    </Button>{'   '}
                                    {isAdminView && <Button
                                        className='disp-inline-block'
                                        color={viewMode === 'adminView' ? 'primary' : 'secondary'}
                                        onClick={() => this.onClickViewMode('adminView')}
                                    >
                                        Admin View
                                    </Button>}
                                    <Button
                                        className='disp-inline-block'
                                        color='primary'
                                        onClick={() => this.onClickCustomerFreightProvider()}
                                        disabled={isLoggedIn === 'true' ? null : 'disabled'}
                                    >
                                        Customer Freight Provider
                                    </Button>
                                </h3>
                                {(bok_1 && bok_1['b_client_name'] === 'Jason L' && isTimerRunning) &&
                                    <h4 className='c-red'>Deliver-ME is still searching for cheaper prices options. Any additional prices will be displayed below when received.</h4>
                                }
                                {pricings.length > 0 ?
                                    <table className="table table-hover table-bordered sortable fixed_headers">
                                        <thead>
                                            <tr>
                                                <th>Freight Provider</th>
                                                <th>Service (Vehicle)</th>
                                                <th className={viewMode === 'salesView' ? 'none' : null}>Cost $</th>
                                                <th className={viewMode === 'salesView' ? 'none' : null}>Fuel Levy %</th>
                                                <th className={viewMode === 'salesView' ? 'none' : null}>Fuel Levy $</th>
                                                <th className={viewMode === 'salesView' ? 'none' : null}>Extra $</th>
                                                <th className={viewMode === 'salesView' ? 'none' : null}>Total $</th>
                                                <th className={viewMode === 'salesView' ? 'none' : null} title="Client Customer Markup ">CC Markup %</th>
                                                {(bokWithPricings && bokWithPricings.b_094_client_sales_total) ? <th>% of Sales Order Total</th> : ''}
                                                <th onClick={() => this.onClickColumn('lowest')}>Sell $ (click & sort)</th>
                                                <th className={viewMode === 'salesView' ? 'none' : null} onClick={() => this.onClickColumn('fastest')}>ETA (click & sort)</th>
                                                {isPricingPage && !isSalesQuote && <th>Action (Select)</th>}
                                                {isPricingPage && !isSalesQuote && <th>Action (Lock)</th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pricings}
                                        </tbody>
                                    </table>
                                    :
                                    <p>No results</p>
                                }
                                <div className="decision">
                                    {(!isSalesQuote && bok_1 && bok_1['b_client_name'] !== 'Jason L') &&
                                        <Button
                                            disabled={canBeChanged ? null : 'disabled'}
                                            color="primary"
                                            onClick={() => this.onClickBookBtn()}
                                        >
                                            {this.props.bookedSuccess || (bokWithPricings && Number(bokWithPricings['success']) !== 3) ? 'Booked' : 'Book'}
                                        </Button>
                                    }
                                    {(bok_1 && bok_1['b_client_name'] === 'Jason L') &&
                                        <Button
                                            disabled={canBeChanged ? null : 'disabled'}
                                            color="success"
                                            title={!canBeChanged ? 'This booking has already been sent to Deliver-ME. Changes need to be made in the Deliver-ME portal'
                                                : 'WARNING - This option books the freight now with the info on the screen as is and will not process any changes you make the Sales Order from this point forward. Are you sure you wish to continue?'}
                                            onClick={() => this.toggleTriggerEmailModal()}
                                        >
                                            Send Booking Now <i className="fa fa-envelope"></i>
                                        </Button>
                                    }
                                    <Button
                                        disabled={canBeChanged ? null : 'disabled'}
                                        color="danger"
                                        onClick={() => this.onClickCancelBtn()}
                                    >
                                        {this.props.canceledSuccess ? 'Quote Canceled' : 'Cancel Quote'}
                                    </Button>
                                </div>
                            </LoadingOverlay>
                        </div>
                    }

                    <ExtraCostSummarySlider
                        isOpen={this.state.isShowExtraCostSummarySlider}
                        toggleSlider={this.toggleExtraCostSummarySlider}
                        selectedPrice = {this.state.selectedPrice}
                        bok_2s = {bokWithPricings ? bokWithPricings['bok_2s'] : []}
                    />

                    <PalletSlider
                        isOpen={this.state.isShowPalletSlider}
                        toggleSlider={this.togglePalletSlider}
                        onCancelAutoRepack={this.onCancelAutoRepack}
                        onSelectPallet={(palletId) => this.onSelectPallet(palletId)}
                    />

                    <BokLineSlider
                        isOpen={this.state.isShowBokLineSlider}
                        toggleSlider={this.toggleBokLineSlider}
                        line={this.state.selectedLine}
                        onSubmit={(newLineData, type) => this.onUpdateBokLine(newLineData, type)}
                        packageTypes={this.props.packageTypes}
                    />

                    <CustomerFreightProviderSlider
                        isOpen={this.state.isShowCustomerFreightProviderSlider}
                        pkAutoId={bokWithPricings ? bokWithPricings['pk_auto_id'] : 0}
                        toggleSlider={this.toggleCustomerFreightProviderSlider}
                        quote={this.state.selectedQuote}
                        onSubmit={() => this.onSubmitCustomerFreightProvider()}
                    />

                    <ConfirmModal
                        isOpen={this.state.isShowTriggerEmailModal}
                        onOk={() => this.onClickConfirmBtn('trigger-email')}
                        onCancel={this.toggleTriggerEmailModal}
                        title={'Send Booking Now?'}
                        text={'WARNING - This option books the freight now with the info on the screen as is and will not process any changes you make the Sales Order from this point forward. Are you sure you wish to continue?'}
                        okBtnName={'Yes'}
                    />

                    <ConfirmModal
                        isOpen={this.state.isShowDeleteConfirmModal}
                        onOk={() => this.onUpdateBokLine(null, 'delete')}
                        onCancel={this.toggleDeleteConfirmModal}
                        title={'Confirmation Modal'}
                        text={'Do you really want to delete this line?'}
                        okBtnName={'Delete'}
                    />

                    <ConfirmModal
                        isOpen={this.state.isShowDeleteQuoteConfirmModal}
                        onOk={() => this.onDeleteQuote()}
                        onCancel={() => this.toggleDeleteQuoteConfirmModal()}
                        title={'Confirmation Modal'}
                        text={'Do you really want to delete this quote?'}
                        okBtnName={'Delete'}
                    />

                    <ConfirmModal
                        isOpen={this.state.isShowManualRepackModal}
                        onOk={() => this.onClickConfirmBtn('manual-from-original')}
                        onOk2={() => this.onClickConfirmBtn('manual-from-auto')}
                        onOk3={() => this.onClickConfirmBtn('enter-from-scratch')}
                        onCancel={() => this.toggleManualRepackModal()}
                        title={'Manual Repack source selection'}
                        text={'Copy data for manual re-repack from?'}
                        okBtnName={'From Send As Is'}
                        ok2BtnName={'From Auto Repack'}
                        ok3BtnName={'Enter from Scratch'}
                    />

                    
                </section>
            </LoadingOverlay>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        errorMessage: state.bok.errorMessage,
        bokWithPricings: state.bok.BOK_with_pricings,
        needToUpdatePricings: state.bok.needToUpdatePricings,
        loadSuccess: state.bok.loadSuccess,
        bookedSuccess: state.bok.bookedSuccess,
        canceledSuccess: state.bok.canceledSuccess,
        selectPricingSuccess: state.bok.selectPricingSuccess,
        repackSuccess: state.bok.repackSuccess,
        lineOperationSuccess: state.bok.lineOperationSuccess,
        packageTypes: state.extra.packageTypes,
        username: state.auth.username,
        clientname: state.auth.clientname,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getBokWithPricings: (identifier) => dispatch(getBokWithPricings(identifier)),
        selectPricing: (costId, identifier, client_overrided_quote) => dispatch(selectPricing(costId, identifier, client_overrided_quote)),
        onBookFreight: (identifier) => dispatch(bookFreight(identifier)),
        onCancelFreight: (identifier) => dispatch(cancelFreight(identifier)),
        sendEmail: (identifier) => dispatch(sendEmail(identifier)),
        onAddBokLine: (line) => dispatch(onAddBokLine(line)),
        onUpdateBokLine: (lineId, line) => dispatch(onUpdateBokLine(lineId, line)),
        onDeleteBokLine: (lineId) => dispatch(onDeleteBokLine(lineId)),
        getPackageTypes: () => dispatch(getPackageTypes()),
        repack: (bookingId, repackStatus, palletId) => dispatch(repack(bookingId, repackStatus, palletId)),
        setNeedToUpdatePricings: () => dispatch(setNeedToUpdatePricings()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BokPricePage);



// WEBPACK FOOTER //
// ./src/pages/customer/BokPricePage.js